import { ArrowRightIcon, ChatIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';
import { HalfWidthContent } from '../tabs/OverviewTab/OverviewTab.styles';

/**
 * GMR air ambulance card for the tools tab.
 * @param {Function} onClick - Callback function when the card is clicked
 */
const ToolsAirAmbulanceCard = ({ onClick = () => {} }) => {
  return (
    <HalfWidthContent
      backgroundColor="background"
      cursor="pointer"
      data-name="tools-air-ambulance-card"
      onClick={onClick}
      position="relative"
      maxHeight="64px"
    >
      <Box
        align="center"
        height="32px"
        horizontal={true}
        justify="space-between"
      >
        <Box flow={4}>
          <Box horizontal>
            <ChatIcon color="primaryText" height={12} width={12} />
            <Text
              color="primaryText"
              data-name="tools-air-ambulance-card-title"
              fontWeight="bold"
              lineHeight="1"
              marginLeft="4px"
              size="normal"
            >
              Air Ambulance
            </Text>
          </Box>
          <Text
            color="secondaryText"
            data-name="tools-air-ambulance-card-subtitle"
            lineHeight="1"
            size="xsmall"
          >
            Local Air Providers
          </Text>
        </Box>
        <Box
          borderWidth="1px"
          borderStyle="solid"
          borderColor="heavyLineOutline"
          borderRadius="5px"
          data-name="tools-air-ambulance-card-icon"
        >
          <ArrowRightIcon color="secondaryText" height="20px" width="22px" />
        </Box>
      </Box>
    </HalfWidthContent>
  );
};

export default ToolsAirAmbulanceCard;
